module.exports = __webpack_public_path__ + "img/Character_Gorou_Thumb.a19cb7fc.png";